import KDHeader from './kd-header.vue';
export default KDHeader;


//////////////////
// WEBPACK FOOTER
// ./components/kd-header/index.js
// module id = null
// module chunks = 